import user from './user';
import common from './common';
import feedback from './feedback';
import crmFeedback from './crm/feedback';

// 主服务
const server = `${process.env.REACT_APP_SERVER}`;

// CRM服务
const crmServer = `${process.env.REACT_APP_CRM_SERVER}`;

export default {
  user: user(server),
  common: common(server),
  feedback: feedback(server),
  crmFeedback: crmFeedback(crmServer),
};
